import SidebarBookingsRepliesReplyController from 'uplisting-frontend/pods/-sidebar/bookings/replies/reply/controller';

export default class ProtectionOverviewBookingsRepliesReplyController extends SidebarBookingsRepliesReplyController {}
